import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Disable console logging in production to prevent DevTools memory leaks
  if (window) {
    window.console.log = () => { };
    window.console.debug = () => { };
    window.console.info = () => { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

  if('serviceWorker' in navigator){
  navigator.serviceWorker.register('firebase-messaging-sw.js').then((registration)=>{
  }).catch((error)=>{
    console.error('service failed', error)
  })
}
